import { Card, Rate, Typography } from "antd";
const { Text } = Typography;

const SingleLessonRatingCard = ({ userRating }: any) => {
  return (
    <div>
      <div className="flex flex-col gap-2">
        {userRating.ratings.map((rating: any) => (
          <div key={rating?.id} className="flex items-center justify-between ">
            <Text className=" text-neutral-600 text-sm font-medium block w-3/4 xl:w-4/5">
              {rating.question.question}
            </Text>
            <Rate
              rootClassName="text-rose-400"
              disabled
              value={rating?.rating}
            />
          </div>
        ))}
      </div>
      {userRating?.feedbacks.length > 0 && (
        <>
          <div className="border-b  border-neutral-200 my-3"></div>
          <Text className="block text-neutral-600 text-xs font-semibold mb-2">
            Feedback:
          </Text>
          <Text className="block text-neutral-600 text-xs font-medium">
            {userRating?.feedbacks[0]?.feedback}
          </Text>
        </>
      )}
    </div>
  );
};

export default SingleLessonRatingCard;
